/**
 * Validate an untrusted `?next=` / redirect target as a same-origin path.
 *
 * Rejects anything that isn't a single-leading-slash absolute path: protocol
 * (`http:`), protocol-relative (`//host`), backslash variants (`/\host` — which
 * browsers and the Next router normalise into `//host`), and control chars.
 * Used by BOTH the login page (client `router.push`, no origin prefix — the
 * risky one) and the callback route, so the two validators can never drift.
 */

const BACKSLASH = 0x5c;

export function safeNextPath(next: string | null | undefined): string | null {
  if (!next) return null;
  // Must start with a single slash, and the second char must not turn it into
  // a protocol-relative ("//") or backslash-normalised ("/\") off-site URL.
  if (next[0] !== "/") return null;
  if (next[1] === "/" || next[1] === "\\") return null;
  // Reject control chars and backslashes anywhere in the rest.
  for (let i = 0; i < next.length; i++) {
    const code = next.charCodeAt(i);
    if (code < 0x20 || code === BACKSLASH) return null;
  }
  return next;
}
